// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-courses-modal__content-wrapper[data-v-64b8aba6] {\n  display: block;\n  width: 100%;\n  padding: 35px;\n  padding-top: 10px;\n}\n.prof-courses-modal__add-course-btn[data-v-64b8aba6] {\n  display: inline-block;\n  width: auto;\n  margin-top: 10px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
